// extracted by mini-css-extract-plugin
export var block = "play-module--block--2Bqvi";
export var bg = "play-module--bg--2wwmu";
export var bgMask = "play-module--bgMask--3Tl8v";
export var awards = "play-module--awards--143rC";
export var awardsContainer = "play-module--awardsContainer--1ZGek";
export var andMore = "play-module--andMore--2omXQ";